import { useQuery } from '@tanstack/react-query'

import API from '../../../utils/api'

export const useCatalogFavorites = () => {
  const { data, isLoading, refetch, error } = useQuery(
    ['/GamesCatalog/myFavorites'],
    API.getMyFavoriteGames,
    {
      staleTime: Infinity,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  )

  return {
    games: data?.data?.games || [],
    refetch,
    error,
    isLoading,
  }
}
